import { LAYOUT } from "@/router/constant";
import { AppRouteModule } from "@/router/types";
import { t } from '@/hooks/web/useI18n';

const tool: AppRouteModule = {
    path: '/tool',
    name: 'Tool',
    component: LAYOUT,
    meta: {
        title: t('routes.index.tool.tool'),
        hideMenu: true,
    },
    children: [
        {
            path: 'makePgn',
            name: 'ToolMakePgn',
            component: () => import('@/views/main/tool/makePgn.vue'),
            meta: {
                title: t('routes.index.tool.makePgn'),
                hideMenu: true,
            },
        },
    ],
}

export default tool;